export default "__VITE_ASSET__5TdV$5gQ__"